import React, { Fragment } from 'react'

const HeadTitle = (props) => {
  const { title, discription } = props
  return (
    <Fragment>
      <div className="text-center pt-4 pb-1 mb-2 w-100" style={{ backgroundColor: '#f9f9f9' }}>
        <h3 className="text-danger">{title}</h3>
        <p>{discription}</p>
      </div>
    </Fragment>
  )
}

export default HeadTitle
